/**
 * lucide-react v0.292.0 - ISC
 */
import createLucideIcon from '../createLucideIcon.js';
var ChevronRight = createLucideIcon("ChevronRight", [["path", {
  d: "m9 18 6-6-6-6",
  key: "mthhwq"
}]]);
export { ChevronRight as default };